<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Minha Conta" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
        <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
        <b-spinner class="ml-2" variant="danger"></b-spinner>
      </div>
      <div class="row">
        <div class="col-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <form class="forms-sample">
                <div class="row justify-content-between">
                  <div class="col-md-4 col-sm-12 col-xs-12 col-xl-3 col-lg-3">
                    <UploadAvatar @input="receberDadosUploadAvatar" uploadFileRef="avatarMinhaConta" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" :codigoFotoUsuario="f_photo_usuario"/>
                    <div div class="avisoDanger text-left mt-1">{{retorno.listaDeErros['f_photo.*']}}</div>
                  </div>
                  <div class="col-md-8 col-sm-12 col-xs-12 col-xl-8 col-lg-8">
                    <div class="row">
                      <div class="form-group col-sm-12 col-xl-8">
                        <label for="inputNomeCompleto" class="required">Nome Completo</label>
                        <input type="text" v-model="formulario.f_name" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputNomeCompleto">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_name}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-4">
                        <label for="inputDataNascimento" class="required">Data Nascimento</label>
                        <Datefield v-model="formulario.f_birthday" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" id="inputDataNascimento"/>
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_birthday}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-4">
                        <label for="inputTelefone">Telefone</label>
                        <input type="text" v-mask="mascaraTelefoneCelular(formulario.f_extension)" v-model="formulario.f_extension" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputTelefone">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_extension}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-8">
                        <label for="inputEmail" class="required">E-mail</label>
                        <input type="email" v-model="formulario.f_email" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputEmail" placeholder="email@example.com">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_email}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-4">
                        <label for="inputNovaSenha">Senha Atual</label>
                        <input type="password" v-model="formulario.current_password" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="off" :readonly="apenasLeitura" @focus="definirFlagApenasLeitura(false)" class="form-control" id="inputSenha">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.current_password}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-4">
                        <label for="inputNovaSenha">Nova Senha</label>
                        <input type="password" v-model="formulario.new_password" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="off" :readonly="apenasLeitura" @focus="definirFlagApenasLeitura(false)" class="form-control" id="inputNovaSenha">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.new_password}}</div>
                      </div>
                      <div class="form-group col-sm-12 col-xl-4">
                        <label for="inputConfirmarSenha">Confirmar Senha</label>
                        <input type="password" v-model="formulario.confirm_password" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="off" :readonly="apenasLeitura" @focus="definirFlagApenasLeitura(false)" class="form-control" id="inputConfirmarSenha">
                        <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.confirm_password}}</div>
                      </div>
                      <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                        <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                        <b-spinner class="ml-2" variant="danger"></b-spinner>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-footer">
              <div class="text-right">
                <div class="row btn-group btn-group-justified" role="group">
                  <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button></div>
                  <router-link class="" to="/inicio">
                    <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div> <!-- card ends -->
        </div>
      </div>
      <!-- row ends -->

    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->

</div>
<!-- ./wrapper -->
</template>

<script>
import MinhaConta from './js'
export default MinhaConta
</script>

<style scoped>
@import "./scss/minhaConta.scss";
</style>
